import { Hero, PopularProducts, CustomerReviews, Services, Footer, SuperQuality, SpecialOffer, Subscribe } from "./sections";
import Nav from "./components/Nav.jsx";


export default function App() {
  return (
    <main className="relative">
        <Nav/> 
        <section className="xl:padding-1 wide:padding-r padding-b">
          <Hero /> 
        </section>
        <section className="padding">
          <PopularProducts />
        </section>
        <section className="padding">
          <SuperQuality />
        </section>
        <section className="padding-x py-10">
          <Services />
        </section>
        <section className="padding">
          <SpecialOffer />
        </section>
        <section className="bg-pale-blue py-50">
          <CustomerReviews />
        </section>
        <section className="padding-x sm:py-32 py-16 w-full">
          <Subscribe />
        </section>
        <section className="padding-x padding-t pb-8 bg-black">
          <Footer/>
        </section>
    </main>
  )
}
